import React from 'react';
import { Menu, MenuItem, MenuDivider, Intent } from "@blueprintjs/core";

class SessionTableCxtMenu extends React.Component {

    handleChangeStatusToOpen = () => this.props.onChangeStatus(this.props.session, 'OPEN');
    handleChangeStatusToClose = () => this.props.onChangeStatus(this.props.session, 'CLOSE');
    handleEdit = () => this.props.onEdit(this.props.session);
    handleResult = () => this.props.onResult(this.props.session);
    handleFeedbacks = () => this.props.onFeedback(this.props.session);
    handleAttributes = () => this.props.onAttributes(this.props.session)
    handleDeleteResults = () => this.props.onDeleteResults(this.props.session);
    handleDelete = () => this.props.onDelete(this.props.session);
    handleAccess = () => this.props.onAccess(this.props.session);
    handleAccessResults = () => this.props.onAccessResult(this.props.session);
    handleExportResults = () => this.props.onExportResults(this.props.session);
    handleMonitoring = () => this.props.onMonitoring(this.props.session);
    handleDuplicate = () => this.props.onDuplicate(this.props.session);
    handleNewResults = () => this.props.onNewResults(this.props.session)

    render() {
        return (
            <Menu key="menu">
                <MenuDivider title="Play" />
                {/* A hotfix to avoid submenu to automaticaly open */}
                <MenuItem className="hide" disabled={true} text="" />
                {/* ---------------------------------------------- */}
                <MenuItem
                    icon="play"
                    text="Access"
                    onClick={this.handleAccess}
                    disabled={(this.props.session.metadata && this.props.session.metadata.shortname && this.props.session.data && this.props.session.data.sequences && this.props.session.data.sequences.length !== 0) ? false : true} />
                <MenuItem
                    icon="control"
                    text="Monitor"
                    onClick={this.handleMonitoring}
                    disabled={(this.props.session.metadata && this.props.session.metadata.shortname && this.props.session.data && this.props.session.metadata.type === 'PILOTED') ? false : true} /> {/* Use a Session Type Constant*/}
                <MenuItem
                    icon="comparison"
                    text="Access results"
                    onClick={this.handleAccessResults}
                    disabled={(this.props.session.metadata && this.props.session.metadata.shortname && this.props.session.data && this.props.session.data.sequences && this.props.session.data.sequences.length !== 0) ? false : true} />
                <MenuItem
                    icon="download"
                    text="Export results"
                    onClick={this.handleExportResults}
                />
                <MenuDivider title="Modify" />
                <MenuItem
                    icon="edit"
                    text="Edit"
                    onClick={this.handleEdit} />
                <MenuItem
                    icon="list"
                    text="Change status">
                    <MenuItem
                        text="Open"
                        onClick={this.handleChangeStatusToOpen} />
                    <MenuItem
                        text="Close"
                        onClick={this.handleChangeStatusToClose} />
                </MenuItem>
                <MenuDivider />
                <MenuItem
                    icon="new-object"
                    text="Duplicate"
                    onClick={this.handleDuplicate} />
                <MenuDivider />
                <MenuItem
                    intent={Intent.DANGER}
                    icon="trash"
                    text="Delete Results"
                    onClick={this.handleDeleteResults} />
                <MenuItem
                    intent={Intent.DANGER}
                    icon="trash"
                    text="Delete Session"
                    onClick={this.handleDelete} />
            </Menu>
        )
    }
}

export default SessionTableCxtMenu;